module.exports = __webpack_public_path__ + "img/1970East-054_WEB-min.536d6b8d.jpg";